enum ROUTE_ENUM {
  HOME = "/",
  LOGIN = "/",
  DASHBOARD = "/dashboard",
  REGISTER = "/register",
  USERS = "/dashboard/users",
  ORDERS = "/dashboard/orders",
  REPORTS = "/dashboard/reports",
  PRICES = "/dashboard/prices",
  MARGINS = "/dashboard/margins",
}

export default ROUTE_ENUM;
